<template>
  <div
    class="c-globalPopupModal"
    v-if="globalPopup.popupType && isPopUp"
  >
    <div class="c-globalPopup">
      <div class="c-globalPopup_inner">
        <div
          class="c-lottery"
          v-if="globalPopup.popupType === 'lottery'"
        >
          <c-button
            class="c-globalPopup_modalClose"
            @click="isPopUp = false"
          ></c-button>
          <div class="c-lotteryBody">
            <a
              href="/campaign/lottery"
              class="c-lotteryBody_button"
            >
              くじを引く
            </a>
          </div>
        </div>
        <div
          class="c-coupon"
          v-else-if="globalPopup.popupType === 'coupon'"
        >
          <c-button
            class="c-globalPopup_modalClose"
            @click="isPopUp = false"
          ></c-button>
          <div :class="[ (isActiveBeginerCouponClass && isSP && hasDeviceJudged) ? 'c-couponHeader-firstReview' : 'c-couponHeader' ]">
            <div :class="[ isActiveBeginerCouponClass ? 'c-couponHeader-firstReview_heading' : 'c-couponHeader_heading' ]">
              <div v-if="globalPopup.coupon.isExpiring">
                有効期限が迫っています！
              </div>
              <div v-else-if="isActiveBeginerCoupon(globalPopup.coupon.couponId) && hasDeviceJudged">
                クーポンが付与されました！
              </div>
              <div v-else>
                今すぐ使える！
              </div>
            </div>

            <div :class="[ (isActiveBeginerCouponClass && isPC && hasDeviceJudged) ? 'c-couponHeader-firstReview_ticket' : 'c-couponHeader_ticket' ]">
              <span v-if="globalPopup.coupon.discountType === DISCOUNT_TYPE.AMOUNT">
                <span :class="[ (isActiveBeginerCouponClass && isPC && hasDeviceJudged) ? 'c-couponHeader-firstReview_price' : 'c-couponHeader_price' ]">{{ globalPopup.coupon.discount }}</span> 円<br>
                割引クーポン
              </span>
              <span v-if="globalPopup.coupon.discountType === DISCOUNT_TYPE.RATIO">
                <span :class="[ (isActiveBeginerCouponClass && isPC && hasDeviceJudged) ? 'c-couponHeader-firstReview_price' : 'c-couponHeader_price' ]">{{ globalPopup.coupon.discount }}</span>%<br>
                OFFクーポン
              </span>
            </div>
          </div>
          <div class="c-couponBody">
            <div class="c-couponBodyExpiredDate">
              <div v-if="globalPopup.coupon.isExpiring">
                <div>有効期限</div>
                <div class="c-couponBodyExpiredDate_expired">
                  <span class="c-couponBodyExpiredDate_timeText">本日</span>
                  <span class="c-couponBodyExpiredDate_time">{{ $util.dayjs.unix(globalPopup.coupon.expireDate).format('LT') }}</span>
                  まで
                </div>
              </div>
              <div v-else>
                <div class="c-couponBodyExpiredDate_expired">
                  <span class="c-couponBodyExpiredDate_text">有効期限：</span>
                  残り<span class="c-couponBodyExpiredDate_expiredTime">{{ calcExpiredTime(globalPopup.coupon.expireDate) }}</span>日
                </div>
                <div class="c-couponBodyExpiredDate_dateTime">
                  {{ $util.dayjs.unix(globalPopup.coupon.expireDate).format('lll') }} まで有効
                </div>
              </div>
            </div>

            <div class="c-couponBodyDetail">
              <div class="c-couponBodyDetail_button">
                <c-button-v2
                  href="/points/top"
                  class="c-couponBodyDetailButton"
                  size="m"
                  color="primary"
                  width="220px"
                >
                  詳しくはこちら
                </c-button-v2>
              </div>
              <div>
                【クーポン詳細】
              </div>
              <div class="c-couponBodyDetail_description">
                <div class="c-couponBodyDetail_name">
                  {{ globalPopup.coupon.displayName }}
                </div>
                <div>
                  {{ globalPopup.coupon.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { grpc } from '@improbable-eng/grpc-web'
import { NodeHttpTransport } from '@improbable-eng/grpc-web-node-http-transport'
import { commonMetaData } from '~/store/_helpers/common-helper'

import { UserService } from '~/stub/apigateway/profile/user_pb_service'
import { GetMyGlobalPopupRequest } from '~/stub/apigateway/profile/user_pb'

import { mapGetters } from 'vuex'

const DISCOUNT_TYPE = {
  AMOUNT: 1,
  RATIO: 2
}

const ActiveBeginerCouponId = 240

export default {
  name: 'GlobalPopup',
  data() {
    return {
      DISCOUNT_TYPE,
      isPopUp: false,
      globalPopup: ''
    }
  },
  computed: {
    ...mapGetters('ui', ['isSP', 'isPC', 'hasDeviceJudged']),
    isActiveBeginerCouponClass() {
      return (
        this.isActiveBeginerCoupon(this.globalPopup.coupon.couponId) &&
        !this.globalPopup.coupon.isExpiring
      )
    }
  },
  methods: {
    calcExpiredTime(date) {
      const diff = this.$util.dayjs.unix(date).diff(this.$util.dayjs())
      return Math.floor(this.$util.dayjs.duration(diff).asDays())
    },
    isActiveBeginerCoupon(couponId) {
      return couponId === ActiveBeginerCouponId
    }
  },
  async mounted() {
    const getGlobalPopup = await new Promise((resolve, reject) => {
      const request = new GetMyGlobalPopupRequest()
      const metadata = commonMetaData(this.$store.state)
      grpc.invoke(UserService.GetMyGlobalPopup, {
        request,
        metadata,
        host: process.env.config.grpcWebUrl,
        transport: NodeHttpTransport(),
        onMessage: message => {
          const response = message.toObject()
          resolve(response)
        },
        onEnd: (code, msg, trailers) => {
          if (code !== grpc.Code.OK) {
            reject()
          }
        }
      })
    })

    this.globalPopup = getGlobalPopup
    this.isPopUp = true
  }
}
</script>
<style lang="scss" scoped>
.c-globalPopupModal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: z(global-popup, modal);
  width: 100%;
  height: 100%;
  font-size: 14px;

  user-select: none;
}

.c-globalPopup {
  display: flex;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);

  align-items: center;
  justify-content: center;

  &_inner {
    padding: 20px;

    align-self: center;
  }

  &_modalClose {
    position: absolute;
    top: -15px;
    right: -15px;
    width: 40px;
    height: 40px;
    border: 0;
    background: url('~assets/images/common/coupon/close.svg') no-repeat;
    background-size: contain;
  }
}

.c-coupon {
  position: relative;
  margin: 0 auto;
  padding: 0;
  width: 450px;
  background: $color-white;
}

.c-couponHeader {
  margin: 0;
  width: 450px;
  height: 292px;
  background: url('~assets/images/common/coupon/coupon_background.png') no-repeat;
  background-size: 100%;

  &_heading {
    padding: 15px 0;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
  }

  &_ticket {
    margin: 0 auto;
    padding-top: 40px;
    width: 350px;
    height: 200px;
    background: url('~assets/images/common/coupon/coupon_ticket_background.png') no-repeat;
    background-size: 100%;
    color: $color-white;
    text-align: center;
    font-weight: bold;
    font-size: 36px;
    line-height: 1.7em;
  }

  &_price {
    font-size: 70px;
  }
}

.c-couponHeader-firstReview {
  margin: 0;
  width: 450px;
  height: 292px;
  background: url('~assets/images/common/coupon/coupon_background.png') no-repeat;
  background-size: 100%;

  &_heading {
    padding: 15px 0 7px;
    text-align: center;
    font-weight: bold;
    font-size: 22px;
  }

  &_ticket {
    margin: 0 auto;
    padding-top: 40px;
    width: 320px;
    height: 188px;
    background: url('~assets/images/common/coupon/coupon_ticket_background.png') no-repeat;
    background-size: 100%;
    color: $color-white;
    text-align: center;
    font-weight: bold;
    font-size: 30px;
    line-height: 1.7em;
  }

  &_price {
    font-size: 60px;
  }
}

.c-couponBody {
  text-align: center;
}

.c-couponBodyExpiredDate {
  padding: 10px 0;
  border-top: dotted 1px $color-gray-300;
  border-bottom: dotted 1px $color-gray-300;
  color: $color-gray-700;
  text-align: center;
  font-size: 18px;

  &_expired {
    color: $color-black;
    font-weight: bold;
    font-size: 24px;
  }

  &_timeText {
    color: $color-red-500;
    font-size: 30px;
  }

  &_time {
    color: $color-red-500;
    font-size: 32px;
  }

  &_text {
    color: $color-gray-700;
    font-weight: normal;
  }

  &_expiredTime {
    color: $color-red-500;
    font-size: 32px;
  }

  &_dateTime {
    padding-top: 5px;
    color: $color-gray-900;
    font-size: 14px;
  }
}

.c-couponBodyDetail {
  padding: 12px 0;
  color: $color-gray-900;
  font-size: 14px;

  &_button {
    margin: 0 auto;
    padding: 7px 0 15px;
  }

  &_description {
    margin: 5px 25px;
    padding: 15px;
    background-color: $color-beige-50;
    text-align: left;
  }

  &_name {
    margin-bottom: 4px;
    font-weight: bold;
  }
}

.c-lottery {
  position: relative;
  width: 563px;
  height: 620px;
  background: url('~assets/images/common/coupon/lottery/background.png') no-repeat;
  background-size: contain;
  color: $color-black;
}

.c-lotteryBody {
  position: absolute;
  bottom: 0;
  z-index: z(global-popup, body);
  margin-bottom: 36px;
  width: 563px;
  color: $color-white;
  text-align: center;
  font-size: 16px;

  &_button {
    width: 468px;
    background-color: $ds2-color-coconala-pink;
    color: $ds2-color-white;
    font-size: 30px;
    line-height: 80px;
    border-radius: 11px;
    padding: 0 14px;
    text-align: center;
    font-weight: bold;
    display: inline-block;
  }

  &_notice {
    margin-top: 12px;
    margin-bottom: 12px;
    font-weight: bold;
    font-size: 12px;
  }
}

@media (max-width: breakpoint(Search, S)) {
  .c-globalPopup {
    background: rgba(0, 0, 0, 0.7);

    &_modalClose {
      right: -5px;
      width: 35px;
      height: 35px;
    }
  }

  .c-coupon {
    width: auto;
    border-radius: 5px;
  }

  .c-couponHeader {
    width: auto;
    height: 194px;
    border-radius: 5px;

    &_heading {
      padding: 18px 0 7px;
      font-size: 17px;
    }

    &_ticket {
      padding-top: 28px;
      width: 226px;
      height: 129px;
      font-size: 24px;
    }

    &_price {
      font-size: 44px;
    }
  }

  .c-couponHeader-firstReview {
    width: auto;
    height: 215px;
    border-radius: 5px;

    &_heading {
      padding: 18px 0 7px;
      font-size: 16px;
    }

    &_ticket {
      padding-top: 28px;
      width: 226px;
      height: 129px;
      font-size: 24px;
    }

    &_price {
      font-size: 44px;
    }
  }

  .c-couponBodyExpiredDate {
    padding: 7px 0;
    font-size: 12px;

    &_expired {
      padding-top: 0;
      font-size: 14px;
      line-height: 1;
    }

    &_timeText {
      font-size: 24px;
    }

    &_time {
      font-size: 28px;
    }

    &_text {
      font-size: 14px;
    }

    &_expiredTime {
      font-size: 28px;
    }

    &_dateTime {
      padding-top: 7px;
      font-size: 12px;
    }
  }

  .c-couponBodyDetail {
    font-size: 12px;

    &_button {
      padding: 5px 0 15px;
    }

    &_description {
      margin: 5px 10px;
      padding: 11px;
      text-align: left;
      font-size: 11px;
    }

    &_name {
      font-size: 14px;
    }
  }

  .c-lottery {
    width: 300px;
    height: 414px;
    background: url('~assets/images/common/coupon/lottery/background_sp.png') no-repeat;
    background-size: contain;
  }

  .c-lotteryBody {
    margin-bottom: 28px;
    width: 300px;

    &_notice {
      font-size: 11px;
    }

    &_button {
      width: 250px;
      font-size: 22px;
      line-height: 48px;
      border-radius: 6px;
    }
  }
}
</style>
